import StudentRecipient from "./StudentRecipient";
import EventRecipient from "./EventRecipient";
import { Alert } from "react-bootstrap";

import HopeStudentRecipient from "./HopeStudentRecipient";
import AmtcaPlayerRecipient from "./AmtcaPlayerRecipient";

const recipientComponents = {
    student: StudentRecipient,
    event: EventRecipient,
    hopestudent: HopeStudentRecipient,
    amtcaplayer: AmtcaPlayerRecipient
}
export const RecipientForm = (props) =>{

    let componentName = props.domain.toLowerCase()+props.recipientType.toLowerCase();
    console.log("Component Name:"+componentName);
    let RecipientForm = recipientComponents[componentName];

    if (!RecipientForm){
        RecipientForm = recipientComponents[props.recipientType.toLowerCase()];
    }

    if (!RecipientForm){
        return <Alert variant="danger">Recipient type is not supported</Alert> 
    }
    return <RecipientForm {...props}/>;
}